import { LegalLayout } from "@/components/LegalLayout";
import { Mail, Phone, MapPin, Clock } from "lucide-react";

export default function ContactPage() {
  return (
    <LegalLayout title="Contact Us" lastUpdated="February 2026" testId="contact-page">
      <p>
        We'd love to hear from you. Whether you have a billing question, a feature
        request, or need help with a chapter — drop us a line and we'll respond
        within 1 business day.
      </p>

      <div className="not-prose grid sm:grid-cols-2 gap-4 my-8">
        <a
          href="mailto:brajeshc56@gmail.com"
          data-testid="contact-email-card"
          className="tactile-card p-5 flex items-start gap-3 hover:scale-[1.01] transition-transform"
        >
          <div className="w-10 h-10 rounded-xl bg-[hsl(var(--brimi-blue))]/15 text-[hsl(var(--brimi-blue))] flex items-center justify-center shrink-0">
            <Mail className="w-5 h-5" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider font-bold text-muted-foreground">Email</div>
            <div className="font-semibold mt-0.5 break-all">brajeshc56@gmail.com</div>
          </div>
        </a>

        <a
          href="tel:+917983633563"
          data-testid="contact-phone-card"
          className="tactile-card p-5 flex items-start gap-3 hover:scale-[1.01] transition-transform"
        >
          <div className="w-10 h-10 rounded-xl bg-[hsl(var(--brimi-coral))]/15 text-[hsl(var(--brimi-coral))] flex items-center justify-center shrink-0">
            <Phone className="w-5 h-5" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider font-bold text-muted-foreground">Phone</div>
            <div className="font-semibold mt-0.5">+91 79836 33563</div>
          </div>
        </a>

        <div className="tactile-card p-5 flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-[hsl(var(--brimi-mint))]/30 text-foreground flex items-center justify-center shrink-0">
            <MapPin className="w-5 h-5" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider font-bold text-muted-foreground">Address</div>
            <div className="font-semibold mt-0.5 leading-snug">
              1 MP Road, Tundla<br />
              Dist. Firozabad, UP — 283204<br />
              India
            </div>
          </div>
        </div>

        <div className="tactile-card p-5 flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-[hsl(var(--brimi-yellow))]/40 text-foreground flex items-center justify-center shrink-0">
            <Clock className="w-5 h-5" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider font-bold text-muted-foreground">Support hours</div>
            <div className="font-semibold mt-0.5 leading-snug">
              Mon – Sat<br />
              10:00 AM – 6:00 PM IST
            </div>
          </div>
        </div>
      </div>

      <h2>Grievance Officer</h2>
      <p>
        In accordance with the Information Technology Act, 2000 and rules made
        thereunder, the contact details of the Grievance Officer are provided below:
      </p>
      <ul>
        <li><strong>Name:</strong> Brajesh Chaudhary (Proprietor)</li>
        <li><strong>Email:</strong> <a href="mailto:brajeshc56@gmail.com">brajeshc56@gmail.com</a></li>
        <li><strong>Phone:</strong> +91 79836 33563</li>
        <li><strong>Address:</strong> 1 MP Road, Tundla, Dist. Firozabad, UP — 283204</li>
      </ul>
      <p>
        We acknowledge complaints within 24 hours and resolve them within 15 working days.
      </p>
    </LegalLayout>
  );
}
